import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '../../../../utils/rtkBaseQuery';

const baseQuery = createBaseQueryWithReauth(
  `${process.env.REACT_APP_BACKEND_URL}health`,
);

export const offersApi = createApi({
  reducerPath: 'offersApi',
  baseQuery: baseQuery,
  tagTypes: ['Covers'],
  endpoints: (builder) => ({
    getAvailableCovers: builder.query({
      query: (id) => `getAvailableCovers/${id}/`,
      providesTags: [{ type: 'Covers' }],
    }),
  }),
});

export const { useGetAvailableCoversQuery } = offersApi;
